import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Chart from 'react-apexcharts'

import { get } from 'lodash'

import { PortalLayout } from '../../components'
import LayoutImageBg from '../../../../assets/images/farmer-portal-reports.png'
import ReportIcon from '../../../../assets/images/productivity-report.png'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'

import './Styles.css'

const PopulationRangeByProductivity = ({ history, location }) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [report, setReport] = useState([])
  const [qttLocations, setQttLocations] = useState('0')

  useLayoutEffect(() => {
    if (!currentUser) {
      return history.push('/farmers/portal')
    }
  }, [])

  useEffect(() => {
    const { material } = get(location, 'state')
    const city = JSON.parse(sessionStorage.getItem('selected_city')) || {}

    const { macroRegion, microRegion } = city

    fetchReport({ macroRegion, microRegion, materialsI2x: [material] })
  }, [])

  useEffect(() => {
    countLocations()
  }, [])

  async function countLocations() {
    const { count = 0 } = await request(api.countLocations())
    setQttLocations(new Intl.NumberFormat('pt-BR').format(count))
  }

  async function fetchReport(filters) {
    const { populationAndProductivity = {} } = await request(api.dashboardFarmerPortal(filters))

    const range = Object.values(populationAndProductivity)

    if (range.length === 0) return

    const productivity = []
    const camps = []

    range.reverse().forEach((round) => {
      const qttCamps = round.length
      const prod = round.reduce((acc, item) => acc + item.productivity, 0) / qttCamps
      camps.push(qttCamps)
      productivity.push(parseInt(prod) || 0)
    })

    setReport([
      {
        name: 'Produtividade sc/ha',
        data: productivity
      },
      {
        name: 'Quantidade de campos',
        data: camps
      }
    ])
  }

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      }
    },
    colors: ['#22C787', '#843EF7'],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetX: 20,
      style: {
        fontSize: '12px',
        colors: ['#22C787', '#843EF7']
      }
    },
    stroke: {
      show: false
    },
    tooltip: {
      enabled: false
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left'
    },
    xaxis: {
      categories: ['320 a 280', '280 a 240', '240 a 200', '200 a 160']
    }
  }

  return (
    <PortalLayout
      bgImage={LayoutImageBg}
      centerImage={ReportIcon}
      title="Resultados do relatório"
      subtitle={getMessage('farmer.portal.population.variety')}
      showAction
    >
      <div className="population-range-by-productivity">
        <div className="wrapper">
          <p className="title">{getMessage('farmer.portal.population.variety')}</p>
          <p className="subtitle">
            Os dados informados são relacionados a safra 2021/2022 e de um total de {qttLocations} agricultores
          </p>

          <div className="chart-box">
            <Chart options={options} series={report} type="bar" height="350" />
          </div>
        </div>
      </div>
    </PortalLayout>
  )
}

export default PopulationRangeByProductivity
